//core
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

//redux
import {
    editFrameworkDialog,
    hideEditFramework, isLoadingUpdateFramework
} from "../../../../store/slice";

//material
import {Avatar, Button, Dialog, DialogActions, DialogContent,} from "@mui/material";
import {frameworkInputType} from "../../../../types";
import {Typo} from "../../../../../../../shared/components/Typography";
import CloseIcon from "@material-ui/icons/Close";
import {Flex} from "../../../../../../../shared/components/Layouts";
import {UploadFileBTN} from "../../../../../../../shared/components/FileBTN/UploadFileBTN";
import {toBase64} from "../../../../../../../shared/utils/base64";
import {addErrorSnack} from "../../../../../../BarsENV/snack/store/slice";
import {LOGO_MAX_SIZE} from "../../../../constants";
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import {UpdateFramework} from "../../../../store/actions";
import {CustomInput, TextArea} from "../../../../../../../shared/components/Inputs";
import {useMainTranslation} from "../../../../../../../shared/hooks/useMainTranslationHooks/useMainTranslation";
import {LoadingButton} from "@mui/lab";

//types
const initialFramework: frameworkInputType = {
    id: '',
    name: '',
    description: '',
    logo: '',
    origin: false,
    type: '',
    visibility: null
};

export const UpdateFrameworkDialog = () => {
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'builderPage.dialogs'});

    const dispatch = useDispatch();
    const dialog = useSelector(editFrameworkDialog);
    const isLoading = useSelector(isLoadingUpdateFramework);

    const [framework, setFramework] = useState<frameworkInputType>(initialFramework);

    useEffect(() => {
        if(dialog.isOpen && dialog.framework){
            setFramework({
                id: dialog.framework.id,
                name: dialog.framework.name,
                logo: dialog.framework.logo ?? '',
                type: dialog.framework.type,
                description: dialog.framework.description,
                origin: true,
                visibility: null
            })
        }else{
            setFramework(initialFramework)
        }
        //eslint-disable-next-line
    }, [dialog.isOpen]);

    const handleClose = (event: React.SyntheticEvent<unknown>, reason?: string) => {
        if (reason !== 'backdropClick') {
            dispatch(hideEditFramework());
        }
    };

    const handleChange = (event:React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setFramework((prevValues) => ({
            ...prevValues,
            [event.target.name]: event.target.value as string,
        }));
    };

    const validate = (): boolean => {
        if(JSON.stringify(dialog.framework) === JSON.stringify(framework)) return false;
        return (
            framework.name.trim().length > 0 &&
            framework.logo.trim().length > 0 &&
            framework.description.trim().length > 0 &&
            framework.type.trim().length > 0
        )
    }

     const setLogo = async(file: any) => {
        if(file && file.size > LOGO_MAX_SIZE){
            dispatch(addErrorSnack(t('Logo is too big!')));
            return;
        }
         const fileBase64: string = await toBase64(file) as string;
         setFramework((prev) => {return {...prev, logo: fileBase64}});
    }

    const handleSubmit = () => {
        if(validate()){
            dispatch(UpdateFramework({framework}));
        }
    }

    return (
        <Dialog open={dialog.isOpen} onClose={handleClose} maxWidth={'lg'} style={{maxHeight: '700px', margin: '30px 0 0 0'}}>
            <Flex w={'100%'} jc={'space-between'} ai={'center'} p={'20px 20px 0 20px'}>
                <Typo fontSize={'24px'} fontWeight={700} letterSpacing={'1.53px'}>Update {framework?.name}</Typo>
                <CloseIcon onClick={handleClose} style={{cursor: 'pointer'}} />
            </Flex>
            <DialogContent style={{width: '30vw'}}>
                <CustomInput
                    disabled
                    margin="dense"
                    id="id"
                    label={t("ID")}
                    type="text"
                    value={framework.id}
                    name={'id'}
                    onChange={handleChange}
                />

                <CustomInput
                    margin="dense"
                    id="name"
                    label={t("Name")}
                    type="text"
                    value={framework.name}
                    name={'name'}
                    onChange={handleChange}
                />

                <CustomInput
                    margin="dense"
                    id="name"
                    label={t("Type")}
                    type="text"
                    value={framework.type}
                    name={'type'}
                    onChange={handleChange}
                />

                <TextArea
                    margin="dense"
                    id="name"
                    label={t("Description")}
                    type="text"
                    value={framework.description}
                    name={'description'}
                    onChange={handleChange}
                    rows={5}
                />

                <Typo fontSize={'1rem'} fontWeight={500} color={'#878BA1'} margin={'10px 0 15px 0'}>{t('Logo (rectangle image up to 1mb)')} </Typo>
                <Flex w={'50%'} jc={'space-between'} ai={'center'}>
                    <Avatar
                        src={(framework.logo.length > 0) ? framework.logo : undefined}
                        sx={{width: '64px', height: '64px', margin: !revDir ? '0 15px 0 0 ' : '0 0 0 15px'}}
                        children={<CropOriginalIcon style={{width: '32px', height: '32px'}}/>}
                    />
                    <UploadFileBTN accept={'image/*'} id={'frameLogo'} onChange={(e) => {
                        setLogo(e.currentTarget.files![0]);
                    }}/>
                </Flex>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{'Close'}</Button>
                <LoadingButton loading={isLoading} onClick={handleSubmit} disabled={!validate()}>{t('SAVE')}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
}